import restApi from '@infrastructure/api/restApi'

export const getFeed = () => restApi.get('/recommendation-feed')
